import { object, string } from 'yup';

export function validationSchema() {
  return object().shape({
    mpsServer: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    mpsUser: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    mpsPassword: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    domainName: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    certFileContent: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    certFileName: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
    certFilePassword: string().when('enabled', {
      is: true,
      then: string().required('Обязательное поле'),
    }),
  });
}
